const license = {
    not_installed: "Aucune licence n'est installée sur cette instance.",
    invalid_key: 'La clé de licence est invalide ou a été falsifiée.',
    expired_key: 'La clé de licence a expiré. Obtenez une nouvelle clé et installez-la à nouveau.',
};
export default Object.freeze(license);
